const reactT = (string, options = []) => {
  if (typeof Drupal !== 'undefined') {
    /*global Drupal:true*/
    return Drupal.t(string, options);
  }
  return string;
};

export default reactT;
